import jaMsg from '@/assets/locale/ja.yml'
import enMsg from '@/assets/locale/en.yml'
import zhMsg from '@/assets/locale/zh.yml'

export { jaMsg, enMsg, zhMsg }
